import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import { base, contact_url, getProductName } from "../../state/api";
import state from "../../state/state";
import { getText, getTextFixed, getUrlPrefix } from "../../state/translations";
import { formatCurrency, getAsset } from "../../utils/utils";
import "./finalizeConfigurationSummary.scss";
import { Svg } from "../svg/svg";
import { getCrosssell } from "../../state/data";
import { isLoggedIn } from "../../utils/login";
export class FinalizeConfigurationSummary extends MithrilTsxComponent {
    relatedItems = {};
    subs = [];
    oninit(v) {
        this.buildRelated(v);
        this.subs.push(state.on("quantity:change", () => {
            this.buildRelated(v);
        }));
    }
    buildRelated(v) {
        for (const art of v.attrs.articles) {
            const variantProduct = Object.values(state.products.variants).find(vr => vr?.artCodeTSNL === art.artCodeTSNL);
            const crossell = getCrosssell(variantProduct ?? art.item, () => {
                m.redraw();
            });
            this.relatedItems[art.artCodeTSNL] = crossell.map(item => ({
                item,
                category: getText(item.category, undefined, item.category),
                qty: state.getCrosssellQuantity(art.artCodeTSNL, item.artCodeTSNL)
            }));
        }
    }
    view(v) {
        const total = v.attrs.articles.reduce((s, x) => {
            const base = (x.item.price ?? 0) * (x.qty ?? 0);
            const cross = (this.relatedItems[x.artCodeTSNL] ?? []).reduce((s, { item, qty }) => s + (item.price ?? 0) * qty, 0);
            return s + base + cross;
        }, 0);
        return m("div", { className: "FinalizeConfigurationSummary" },
            m("div", null,
                v.attrs.articles?.length > 0 &&
                    m("div", { className: "panel" },
                        m("div", { className: "summary-header" },
                            m("span", null, getTextFixed("MY_OVERVIEW"))),
                        m("div", { className: "content" },
                            m("ul", { className: "list" }, v.attrs.articles.map(article => [
                                m("li", null,
                                    m("span", null,
                                        article.qty,
                                        "x ",
                                        getProductName(article.item)),
                                    m("p", null, (isLoggedIn && article.item.price) ? formatCurrency((article.item.price ?? 0) * (article.qty ?? 0)) : "€-,--")),
                                ...(this.relatedItems[article.artCodeTSNL] ?? [])
                                    .filter(item => state.getCrosssellQuantity(article.artCodeTSNL, item.item.artCodeTSNL) > 0)
                                    .map(({ qty, item }) => m("li", { className: "related-item" },
                                    m("span", { className: "indent-icon", "aria-hidden": "true" }, "\u21B3"),
                                    m("span", { className: "related-name" },
                                        qty,
                                        "x ",
                                        getProductName(item)),
                                    m("span", { className: "related-price" }, (isLoggedIn && item.price) ? formatCurrency(item.price * qty) : "€-,--")))
                            ])),
                            m("div", { className: "subtotal" },
                                m("div", { className: "summary" },
                                    m("span", { className: "subtitle" }, getTextFixed("SUBTOTAL", { count: v.attrs.articles.length })),
                                    m("span", { className: "vat" }, getTextFixed("EXC_VAT"))),
                                m("span", null, isLoggedIn ? formatCurrency(total) : "€-,--")),
                            m("button", { className: `button button-default cta ${v.attrs.articles.length === 0 ? "-disabled" : ""}`, onclick: v.attrs.onplaceorder, disabled: v.attrs.articles.length === 0 },
                                m("span", null, getTextFixed("PLACE_ORDER")),
                                m(Svg, { className: "icon", src: getAsset("icons/forward.svg") })))),
                m("div", { className: "help" },
                    m(Svg, { className: "icon", src: getAsset("icons/call.svg") }),
                    m("strong", null, getTextFixed("NEED_HELP")),
                    m("p", null, getTextFixed("NEED_HELP_DESCRIPTION")),
                    m("button", { className: "button button-secondary", type: "button", onclick: () => {
                            const w = window.open(contact_url, "_blank", "noopener,noreferrer");
                        } }, getTextFixed("CONTACT_US")))));
    }
    onremove() {
        for (const sub of this.subs)
            sub.off();
    }
}
